(() => {
  'use strict';

  const STORAGE_KEY = 'bn_project_wall_saved';

  const getSaved = () => {
    try {
      return new Set(JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]'));
    } catch (error) {
      return new Set();
    }
  };

  const setSaved = (saved) => {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(Array.from(saved)));
    } catch (error) {
      // localStorage may be unavailable in preview or private browsing.
    }
  };

  const normalize = (value) => String(value || '').trim().toLowerCase();

  const initProjectWall = (root) => {
    if (!root || root.dataset.bnProjectWallMounted === 'true') return;
    root.dataset.bnProjectWallMounted = 'true';

    const cards = Array.from(root.querySelectorAll('[data-bn-project-card]'));
    const searchInput = root.querySelector('[data-bn-project-search]');
    const filters = Array.from(root.querySelectorAll('[data-bn-project-filter]'));
    const status = root.querySelector('[data-bn-project-status]');
    const empty = root.querySelector('[data-bn-project-empty]');
    const saveButtons = Array.from(root.querySelectorAll('[data-bn-project-save]'));
    const saved = getSaved();

    const updateSaveButtons = () => {
      saveButtons.forEach((button) => {
        const id = button.getAttribute('data-bn-project-save');
        const isSaved = saved.has(id);
        button.setAttribute('aria-pressed', isSaved ? 'true' : 'false');
        button.querySelector('span').textContent = isSaved ? '♥' : '♡';
      });
    };

    saveButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const id = button.getAttribute('data-bn-project-save');
        if (!id) return;
        if (saved.has(id)) saved.delete(id);
        else saved.add(id);
        setSaved(saved);
        updateSaveButtons();
      });
    });

    const applyFilters = () => {
      const query = normalize(searchInput ? searchInput.value : '');
      const activeFilters = filters.reduce((acc, filter) => {
        acc[filter.getAttribute('data-bn-project-filter')] = filter.value;
        return acc;
      }, {});

      let visibleCount = 0;

      cards.forEach((card) => {
        const matchesSearch = !query || normalize(card.dataset.search).includes(query);
        const matchesTechnique = !activeFilters.technique || activeFilters.technique === 'all' || card.dataset.technique === activeFilters.technique;
        const matchesLevel = !activeFilters.level || activeFilters.level === 'all' || card.dataset.level === activeFilters.level;
        const matchesModality = !activeFilters.modality || activeFilters.modality === 'all' || card.dataset.modality === activeFilters.modality;
        const visible = matchesSearch && matchesTechnique && matchesLevel && matchesModality;

        card.hidden = !visible;
        if (visible) visibleCount += 1;
      });

      if (status) {
        status.innerHTML = `Mostrando <strong>${visibleCount}</strong> proyecto${visibleCount === 1 ? '' : 's'} filtrado${visibleCount === 1 ? '' : 's'}`;
      }

      if (empty) empty.hidden = visibleCount !== 0;
    };

    if (searchInput) searchInput.addEventListener('input', applyFilters);
    filters.forEach((filter) => filter.addEventListener('change', applyFilters));

    updateSaveButtons();
    applyFilters();
  };

  const init = () => {
    document.querySelectorAll('[data-bn-project-wall]').forEach(initProjectWall);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
